import * as React from 'react';
import ReactJson from "react-json-view";

const Modal = require('react-modal');

interface Props {
    attrValue: any;
    fieldName: string;
    onRef?: any;
    saveTextAreaModalValue(textValue): void
}

interface State {
    isOpen: boolean;
}

const customStyles = {
    content: {
        border: 'none',
        backgroundColor: "transparent",
        margin: 'auto',
        overflow: 'hidden',
        height: '70%'
    }
};

class EditAttrModal extends React.Component<Props, State> {
    private jsonValue = {};
    constructor(props: Props) {
        super(props);
        this.state = {
            isOpen: false
        };
    }

    componentDidMount(): void {
        if (this.props.onRef) {
            this.props.onRef(this);
        }
        document.addEventListener('keydown', this.textAreaKeyListener);
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.textAreaKeyListener);
    }

    textAreaKeyListener = (e: any) => {
        let keyCode = e.keyCode || e.which;
        if (e.code === 'Escape') {
            this.close();
        }
        if (this.props.attrValue.isJson === true) {
            if (e.ctrlKey && keyCode === 13) {
                setTimeout(() => {
                    this.props.saveTextAreaModalValue(JSON.stringify(this.jsonValue))
                    this.close();
                }, 50)
            }
        }
    };

    open = () => {
        this.setState({
            isOpen: true
        });
    };

    close = () => {
        this.setState({
            isOpen: false
        });
    };

    onKeyDownHandler = (event: any) => {
        let keyCode = event.keyCode || event.which;
        if (this.props.attrValue.isJson === false) {
            let textArea = event.target;

            if (event.ctrlKey && keyCode === 13) {
                this.props.saveTextAreaModalValue(textArea.value)
                this.close();
            }

            if (keyCode === 9) {
                event.preventDefault();
                let v = textArea.value, s=textArea.selectionStart, e=textArea.selectionEnd;
                textArea.value = v.substring(0, s) + '\t' + v.substring(e);
                textArea.selectionStart = textArea.selectionEnd = s + 1;
                return false;
            }
        }
    }

    editJson = (e) => {
        this.jsonValue = e.updated_src;
    }

    addPropToJson = (e) => {
        this.jsonValue = e.updated_src;
    }

    onDelete = (e) => {
        this.jsonValue = e.updated_src;
    }

    renderContent = () => {
        const {attrValue} = this.props;
        if (attrValue.isJson) {
            this.jsonValue = attrValue.value;

            return <div tabIndex={3} style={{overflow: "auto", height: '100%'}}>
                <ReactJson style={{background: '#2D3436', minHeight: '100%'}}
                           enableClipboard={false}
                           theme={'tomorrow'}
                           displayDataTypes={false}
                           onEdit={this.editJson}
                           onAdd={this.addPropToJson}
                           onDelete={this.onDelete}
                           src={attrValue.value}/>
            </div>
        } else {
            return <textarea
                style={{width: '100%', height: '100%', resize: "none", fontFamily: 'monospace', fontSize: 14}}
                id='text-area-navigator'
                defaultValue={attrValue.value}
                className={'text-area-for-edit'}
                autoFocus={true}
                onKeyDown={this.onKeyDownHandler}
            />
        }
    }

    render() {
        const {fieldName} = this.props;

        return (
            <Modal
                isOpen={this.state.isOpen}
                style={customStyles}
                ariaHideApp={false}
                onRequestClose={this.close}
            >
                <div style={{width: '60%', height: '85%'}}
                     className={"container-fluid"}>
                    <div className="row" style={{height: '100%'}}>
                        <div id={'text-area-container'} className='col-lg-12 compare-changes'>
                            <h4 style={{color: '#F5F5F5'}}>Editing: {fieldName}</h4>
                            {this.renderContent()}
                            <button
                                onClick={this.close}
                                className={"btn"}
                                id={'close-modal-btn'}
                                style={{float: "right", marginTop: 5}}>
                                <i className="fas fa-times"> Close</i>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default EditAttrModal



// WEBPACK FOOTER //
// ./app/components/bo-core/instanceLayoutEditor/editAttrModal/EditAttrModal.tsx